export const sceneTunnel = `
    vec3 sceneTunnel(vec3 rd, float time) {
        float r = length(rd.xy); float a = atan(rd.y, rd.x) + time * 0.5;
        float u = 1.0/(r+0.01) + time; float v = a/PI;
        float check = step(0.5, fract(u*2.0)) * step(0.5, fract(v*5.0));
        check = max(check, step(0.5, fract(u*2.0+0.5)) * step(0.5, fract(v*5.0+0.5)));
        return vec3(check) * vec3(1.0, 0.2, 0.5) * r;
    }
`;
